import _ from "lodash";
import { useEffect } from "react";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { useTypedTranslation } from "../../../hooks";
import { Fieldset } from "../../Form";
import { BodyTextM } from "../../Typography";
import { FormValues } from "./EditInvestmentStrategyPage";
import * as Styled from "./EditInvestmentStrategyPage.styled";

export function EditInvestmentStrategyRemainingAllocation() {
    const { t } = useTypedTranslation();

    const { setValue } = useFormContext();

    const calculatedRemaining = useWatch<FormValues, "funds", FormValues["funds"], number>({
        name: "funds",
        compute: (funds: FormValues["funds"]) => {
            return funds.reduce((acc, fund) => {
                return acc - Number(fund.allocation ?? 0);
            }, 100);
        },
    });

    useEffect(() => {
        setValue("remaining", calculatedRemaining, { shouldValidate: true });
    }, [calculatedRemaining, setValue]);

    const { field } = useController({
        name: "remaining",
    });

    return (
        <Fieldset name="remaining">
            <Styled.SpaceBetweenStack>
                <BodyTextM>
                    {t(`investmentStrategy.pensionQuestionnaire.editInvestmentStrategyPage.common.remaining`)}
                </BodyTextM>
                <Styled.BoldBodyTextM>{`${_.isNaN(field.value) ? 0 : field.value} %`}</Styled.BoldBodyTextM>
            </Styled.SpaceBetweenStack>
        </Fieldset>
    );
}
